export default __webpack_public_path__ + "static/media/10_2.f1059c52.jpg";